// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  convoyId: __t.u64().primaryKey().name("convoy_id"),
  worldId: __t.u64().name("world_id"),
  fromSid: __t.u64().name("from_sid"),
  toSid: __t.u64().name("to_sid"),
  commodity: __t.string(),
  qty: __t.u32(),
  valueSov: __t.i64().name("value_sov"),
  fromX: __t.f32().name("from_x"),
  fromZ: __t.f32().name("from_z"),
  toX: __t.f32().name("to_x"),
  toZ: __t.f32().name("to_z"),
  departAt: __t.timestamp().name("depart_at"),
  arriveAt: __t.timestamp().name("arrive_at"),
  status: __t.string(),
  crashX: __t.f32().name("crash_x"),
  crashZ: __t.f32().name("crash_z"),
  downedBy: __t.identity().name("downed_by"),
  updatedAt: __t.timestamp().name("updated_at"),
});
